
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import TextField from '../../TextField';
import useState from '../../../hooks/useState';


interface IUpdateObservationsDialogProps extends IDefaultDialogProps {
    observations: string;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    observations: string;
}

const UpdateObservationsDialog: React.FC<IUpdateObservationsDialogProps> = ({
    open,
    handleClose,
    observations,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        observations: ''
    });


    useEffect(() => {
        if (open) {
            state.update('observations', observations.trim());
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('observations')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <TextField
                        name='observations'
                        value={state.values.observations}
                        onChange={(e) => state.update(e.target.name, e.target.value)}
                        required={false}
                        multiline={true}
                        minRows={10}
                        maxRows={10}
                        className='container-embedded'
                        placeholder='...'
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdateObservationsDialog;